/* eslint-disable */
import styled from 'styled-components'
import { AnswerText } from '../styles'

const SimilarQuestionText = styled(AnswerText)`
  padding: 8px 12px;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: transparent;
    cursor: default;
  }
`

const DropdownButton = styled(AnswerText)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 108%;

  span {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    color: #3a3f62;
  }
`

const PolygonDown = styled.div<{ isVisible: boolean }>`
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 10px solid #616581;
  display: inline-block;
  margin-left: 8px;
  margin-right: 15px;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0.2)};
  align-items: center;
  vertical-align: middle;
`

const SimilarQuestionsDropdown = styled(AnswerText)<{ isLast: boolean }>`
  position: absolute;
  background-color: #ffffff;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  top: ${({ isLast }) => (isLast ? 'auto' : '100%')};
  bottom: ${({ isLast }) => (isLast ? '100%' : 'auto')};
  width: 500px;
  left: -25px;
  max-height: 300px;
  height: auto;
  overflow-y: auto;
  z-index: 1000;
  margin-top: 10px;
  border-radius: 4px;
`

export { SimilarQuestionText, DropdownButton, PolygonDown, SimilarQuestionsDropdown }
